type Props = { variant?: 'dashboard' | 'list' }

export default function AppSkeleton({ variant = 'list' }: Props) {
  return <div className={`app-skeleton app-skeleton-${variant}`} aria-label="Carregando conteúdo" aria-busy="true">
    <div className="skeleton-hero"><i/><b/><span/></div>
    <div className="skeleton-actions">{Array.from({ length: 4 }, (_, i) => <i key={i}/>)}</div>
    <div className="skeleton-list">{Array.from({ length: variant === 'dashboard' ? 5 : 7 }, (_, i) => <div key={i}><i/><span><b/><em/></span><strong/></div>)}</div>
  </div>
}
